import React, { useState, useEffect  } from 'react';
import { Link } from 'react-router-dom';
import { 
  Activity, 
  Users, 
  Map, 
  User, 
  Settings, 
  Bell, 
  Droplets, 
  Award, 
  Calendar, 
  Clock, 
  Flame, 
  BarChart2, 
  TrendingUp, 
  Heart, 
  ArrowRight, 
  Download,
  Plus,
  Pencil,
  LogOut
} from 'lucide-react';
import Navigation from '../components/common/Navigation';
import StepCounter from '../components/dashboard/StepCounter';
import ActivityChart from '../components/dashboard/ActivityChart';
import GoalProgress from '../components/dashboard/GoalProgress';
import Recommendations from '../components/dashboard/Recommendations';
import api from '../request'; // Import the API instance
import ToastMessage from '../components/ToastMessage';
//import GoalModal from '../components/GoalMo/dal';
import { Dialog } from '@headlessui/react';
import GoalModal from '../components/GoalModal';
import Header from "../components/common/Header"
import HotStepperMessages from '../components/dashboard/HotStepperMessages';

const Dashboard = () => {
  // State for active tab
  const [activeTab, setActiveTab] = useState('overview');
  
  // Mock data
   
  
  const weeklySteps = [
    { day: 'Mon', steps: 9123 },
    { day: 'Tue', steps: 7896 },
    { day: 'Wed', steps: 10254 },
    { day: 'Thu', steps: 6543 },
    { day: 'Fri', steps: 8756 },
    { day: 'Sat', steps: 5467 },
    { day: 'Sun', steps: 8234 }
  ];
  

  const achievements = [
    { id: 1, name: "First 5K", icon: <Award size={20} /> },
    { id: 2, name: "Week Streak", icon: <Calendar size={20} /> },
    { id: 3, name: "Early Bird", icon: <Clock size={20} /> }
  ];
  
  const recommendedTips = [
    { id: 1, title: "Try Interval Walking", description: "Alternate between brisk and moderate pace for better calorie burn." },
    { id: 2, title: "Hydration Reminder", description: "Remember to drink water before and after your walks." }
  ];
  
  // Mobile navigation items
  const navigationItems = [
    { icon: <Activity size={20} />, label: 'Dashboard', link: '/dashboard', active: true },
    { icon: <Map size={20} />, label: 'Map', link: '/map', active: false },
    { icon: <Users size={20} />, label: 'Challenges', link: '/hot-stepper', active: false },
    { icon: <User size={20} />, label: 'Profile', link: '/profile', active: false },
    { icon: <Settings size={20} />, label: 'Settings', link: '/settings', active: false },
  ];
  
  const [toast, setToast] = useState({ message: '', type: '' });
  
  const showToast = (message, type = 'success') => {
    setToast({ message, type });
    setTimeout(() => setToast({ message: '', type: '' }), 4000);
  };

  const [goals, setGoals] = useState([]);
  const [selectedGoal, setSelectedGoal] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [todayStatss, setTodayStatss] = useState({
      steps: 0,
      goalSteps: 10000,
    });
  
  useEffect(() => {
  const fetchGoals = async () => {
    try {
      const res = await api.get('/user/goals-progress');
      setGoals(res.data || []);
    } catch (err) {
      console.error('Failed to load goals:', err);
    }
  };

  fetchGoals();
}, []);

  const handleEdit = (goal) => {
    setSelectedGoal(goal);
    setModalOpen(true);
  };

  // const handleGoalSaved = (updatedGoal) => {
  //   setModalOpen(false);
  //   setSelectedGoal(null);
  //   // Refetch or optimistically update `goals` here
  // };
   

  const [newGoal, setNewGoal] = useState(null);
  const [goalModalOpen, setGoalModalOpen] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [goalToEdit, setGoalToEdit] = useState(null);
  const [goalCount, setGoalCount] = useState(0); // Track active goals
  const [activeChallenges, setActiveChallenges] = useState([]);
  const [availableChallenges, setAvailableChallenges] = useState([]);

  useEffect(() => {
    const fetchChallenges = async () => {
      try {
        const res = await api.get('/challenges'); // your endpoint
        setActiveChallenges(res.data.activeChallenges ?? []);
      setAvailableChallenges(res.data.availableChallenges ?? []);
      } catch (err) {
        console.error('Error fetching challenges', err);
      }
    };

    fetchChallenges();
  }, []);

  
  const handleGoalSaved = (savedGoal) => {
    if (goalToEdit) {
      // Update existing goal
      setGoals(prevGoals => 
        prevGoals.map(goal =>  
          goal.id === savedGoal.id ? savedGoal : goal
        )
      );
    } else {
      // Add new goal
      setGoals(prevGoals => [...prevGoals, savedGoal]);
      setGoalCount(prevCount => prevCount + 1);
    }
    // Optional: Show success message
    console.log('Goal saved successfully!');
  };
    // Functions to open/close modal
  const openCreateModal = () => {
    setGoalToEdit(null); // Clear any existing goal data
    setIsModalOpen(true);
  };

  const openEditModal = (goal) => {
    setGoalToEdit(goal); // Set the goal to edit
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setGoalToEdit(null); // Clear goal data when closing
  };
  // const handleCreateGoal = async () => {
  //   try {
  //     const res = await api.post('/goals', newGoal);
  //     showToast('Goal created successfully!', 'success');
  //     setGoalModalOpen(false);
  //     // Reload goals or update state
  //   } catch (err) {
  //     console.error(err);
  //     showToast(err?.response?.data?.message || 'Failed to create goal', 'error');
  //   }
  // };
  const [todayStats, setTodayStats] = useState({
  steps: 0,
  distance: 0,
  calories: 0,
  activeTime: 0,
  goalSteps: 10000,
});

useEffect(() => {
  const fetchStats = async () => {
    try {
      const res = await api.get('/user/today-stats'); // adjust route as needed
      setTodayStats(res.data);
    } catch (err) {
      console.error("Failed to fetch today's stats:", err);
    }
  };

  fetchStats();
}, []);

const [activityData, setActivityData] = useState(null);

useEffect(() => {
  if (activeTab === 'history') {
    const fetchhistory = async () => {
        try {
          const res = await api.get('/activity/history'); // adjust route as needed
          setActivityData(res.data);
        } catch (err) {
          console.error("Failed to fetch today's stats:", err);
        }
      }
    
      fetchhistory();

   };
}, [activeTab]);

//for chats
const [selectedType, setSelectedType] = useState("steps");
const [chartData, setChartData] = useState({ labels: [], values: [] });
useEffect(() => {
    api
      .get(`/activity/chart?type=${selectedType}`)
      .then((res) => setChartData(res.data))
      .catch((err) => console.error("Chart fetch failed:", err));
  }, [selectedType]);

  const handleSelect = (type) => setSelectedType(type);



  const generatePath = (values) => {
  const max = Math.max(...values);
  const min = Math.min(...values);
  const range = max - min || 1;

  return values
    .map((v, i) => {
      const x = (i / (values.length - 1)) * 100;
      const y = 50 - ((v - min) / range) * 50;
      return `${i === 0 ? "M" : "L"}${x},${y}`;
    })
    .join(" ");
};


  const joinChallenge = async (challengeId) => {
  try {
    const response = await api.post(`/challenges/${challengeId}/join`);
     const challenge = availableChallenges.find((c) => c.id === challengeId)
    if (challenge) {
      // Add to active challenges with 0 progress
      setActiveChallenges([
        ...activeChallenges,
        {
          ...challenge,
          progress: 0,
          status: "just-started",
        },
      ])

      // Remove from available challenges
      setAvailableChallenges(availableChallenges.filter((c) => c.id !== challengeId))
    }
 
    
    // Optional: refetch challenge lists or update UI
    // fetchChallenges(); or manually remove from availableChallenges etc.
  } catch (error) {
    if (error.response && error.response.status === 409) {
      setToast("You have already joined this challenge.", 'error')
    } else {
       setToast("An error occurred while joining the challenge.", 'error')
     
    }
    console.error(error);
  }
};

  return (
    <div className="min-h-screen bg-background-light">
            <ToastMessage
            message={toast.message}
            type={toast.type}
            onClose={() => setToast({ message: '', type: '' })}
          />
      {/* Header */}
        <Header />
      {/* Main Content */}
      <main className="max-w-7xl lg:ml-64 mx-auto px-4 py-6">
        {/* Welcome message */}
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-text-primary">Hello, Walker!</h1>
          <p className="text-text-secondary">Let's check your progress today.</p>
        </div>
        <HotStepperMessages />
        {/* Tab Navigation */}
        <div className="flex overflow-x-auto mb-6 mt-6 bg-white rounded-lg shadow-sm p-1">
          <button 
            onClick={() => setActiveTab('overview')} 
            
            className={`px-4 py-2 text-sm font-medium rounded-md whitespace-nowrap ${activeTab === 'overview' ? 'bg-primary text-white' : 'text-text-secondary hover:bg-background-light'}`}
          >
            Overview
          </button>
          {/* <button 
            onClick={() => setActiveTab('insights')} 
            className={`px-4 py-2 text-sm font-medium rounded-md whitespace-nowrap ${activeTab === 'insights' ? 'bg-primary text-white' : 'text-text-secondary hover:bg-background-light'}`}
          >
            Insights & Recommendations
          </button> */}
          <button 
            onClick={() => setActiveTab('history')} 
            className={`px-4 py-2 text-sm font-medium rounded-md whitespace-nowrap ${activeTab === 'history' ? 'bg-primary text-white' : 'text-text-secondary hover:bg-background-light'}`}
          >
            History & Trends
          </button>
          <button 
            onClick={() => setActiveTab('challenges')} 
            className={`px-4 py-2 text-sm font-medium rounded-md whitespace-nowrap ${activeTab === 'challenges' ? 'bg-primary text-white' : 'text-text-secondary hover:bg-background-light'}`}
          >
            Goals & Challenges
          </button>
        </div>

        {/* Tab Content */}
        {activeTab === 'overview' && (
          <div className="space-y-6">
            {/* Today's Stats Cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              <div className="bg-white rounded-xl shadow-sm p-4">
                <div className="flex items-center gap-3 mb-2">
                  <Activity size={20} className="text-primary" />
                  <h3 className="text-sm font-medium">Steps</h3>
                </div>
                <div className="flex items-end gap-2">
                  <span className="text-2xl font-bold">{todayStats.steps.toLocaleString()}</span>
                  <span className="text-text-secondary text-sm mb-1">/ {todayStats.goalSteps.toLocaleString()}</span>
                </div>
              </div>
              
              <div className="bg-white rounded-xl shadow-sm p-4">
                <div className="flex items-center gap-3 mb-2">
                  <Map size={20} className="text-secondary" />
                  <h3 className="text-sm font-medium">Distance</h3>
                </div>
                <div className="flex items-end gap-2">
                  <span className="text-2xl font-bold">{todayStats.distance}</span>
                  <span className="text-text-secondary text-sm mb-1">km</span>
                </div>
              </div>
              
              <div className="bg-white rounded-xl shadow-sm p-4">
                <div className="flex items-center gap-3 mb-2">
                  <Flame size={20} className="text-accent" />
                  <h3 className="text-sm font-medium">Calories</h3>
                </div>
                <div className="flex items-end gap-2">
                  <span className="text-2xl font-bold">{todayStats.calories}</span>
                  <span className="text-text-secondary text-sm mb-1">kcal</span>
                </div>
              </div>
              
              <div className="bg-white rounded-xl shadow-sm p-4">
                <div className="flex items-center gap-3 mb-2">
                  <Clock size={20} className="text-primary" />
                  <h3 className="text-sm font-medium">Active Time</h3>
                </div>
                <div className="flex items-end gap-2">
                  <span className="text-2xl font-bold">{todayStats.activeTime}</span>
                  <span className="text-text-secondary text-sm mb-1">min</span>
                </div>
              </div>
            </div>
            
            {/* Current Goal Progress */}
           {goals && goals.length > 0 && (
              <div className="bg-white rounded-xl shadow-sm p-6">
                <h3 className="text-lg font-medium mb-4">Current Goal Progress</h3>

                {(() => {
                  const currentGoal = goals[0]; // You can sort if needed for most recent
                  const achieved = currentGoal.achieved || 0;
                  const target = currentGoal.target_value || 1;
                  const progressPercent = Math.min(100, Math.round((achieved / target) * 100));

                  const typeLabelMap = {
                    steps: 'Steps',
                    distance: 'Distance',
                    calories: 'Calories',
                    duration: 'Duration',
                  };

                  const durationTextMap = {
                    daily: "Today's",
                    weekly: "This Week's",
                    monthly: "This Month's",
                  };

                  const goalLabel = `${typeLabelMap[currentGoal.type] || ''}`;
                  const remainingLabel = `${target - achieved} ${typeLabelMap[currentGoal.type]} to go!`;

                  return (
                    <div className="flex flex-col md:flex-row items-center gap-6">
                      <div className="w-full md:w-1/3 flex justify-center">
                        <div className="relative h-48 w-48">
                          <svg viewBox="0 0 100 100" className="h-full w-full">
                            {/* Background circle */}
                            <circle 
                              cx="50" cy="50" r="40" 
                              fill="none" 
                              stroke="#e6e6e6" 
                              strokeWidth="10" 
                            />
                            {/* Progress circle */}
                            <circle 
                              cx="50" cy="50" r="40" 
                              fill="none" 
                              stroke="#4CAF50" 
                              strokeWidth="10" 
                              strokeDasharray="251.2" 
                              strokeDashoffset={251.2 - (251.2 * (achieved / target))} 
                              strokeLinecap="round"
                              transform="rotate(-90 50 50)" 
                            />
                          </svg>
                          <div className="absolute inset-0 flex flex-col items-center justify-center">
                            <span className="text-3xl font-bold">{progressPercent}%</span>
                            <span className="text-text-secondary text-sm">{goalLabel} Goal</span>
                          </div>
                        </div>
                      </div>

                      <div className="w-full md:w-2/3">
                        <div className="text-xl font-semibold mb-1">{achieved} / {target} {typeLabelMap[currentGoal.type]}</div>
                        <div className="text-sm text-gray-500">{remainingLabel}</div>

                        <div className="flex gap-4 mt-6">
                          <Link to="/map" className="bg-primary text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-opacity-90 flex items-center gap-2">
                            <Activity size={16} />
                            Start Walk
                          </Link>
                        </div>
                      </div>
                    </div>
                  );
                })()}
              </div>
            )}

            
            {/* Weekly Steps Chart */}
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h3 className="text-lg font-medium mb-4">Weekly Activity</h3>
              <ActivityChart data={weeklySteps} />
            </div>
          </div>
        )}

        {activeTab === 'insights' && (
          <div className="space-y-6">
            {/* Personalized Tips */}
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h3 className="text-lg font-medium mb-4">Personalized Tips</h3>
              <div className="space-y-4">
                {recommendedTips.map(tip => (
                  <div key={tip.id} className="border-l-4 border-primary pl-4 py-2">
                    <h4 className="font-medium">{tip.title}</h4>
                    <p className="text-text-secondary text-sm">{tip.description}</p>
                  </div>
                ))}
              </div>
            </div>
            
            {/* Fitness Level Assessment */}
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h3 className="text-lg font-medium mb-4">Fitness Level Assessment</h3>
              <div className="relative w-full h-4 bg-gray-100 rounded-full mb-2">
                <div className="absolute left-0 top-0 h-full w-3/5 bg-primary rounded-full"></div>
                <div className="absolute left-3/5 top-0 transform -translate-x-1/2 -translate-y-full mt-[-8px]">
                  <div className="bg-primary text-white text-xs px-2 py-1 rounded">You are here</div>
                </div>
              </div>
              <div className="flex justify-between text-sm text-text-secondary">
                <span>Beginner</span>
                <span>Intermediate</span>
                <span>Advanced</span>
              </div>
              
              <div className="mt-4">
                <h4 className="font-medium">Your Fitness Level: Intermediate</h4>
                <p className="text-text-secondary text-sm mt-2">
                  You're making great progress! Your walking pace and consistency show you're building good stamina. 
                  Try adding some inclined routes to challenge yourself further.
                </p>
              </div>
            </div>
            
            {/* Pacing and Technique */}
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h3 className="text-lg font-medium mb-4">Pacing and Technique</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <h4 className="font-medium mb-2">Walking Pace</h4>
                  <div className="flex items-center gap-2">
                    <span className="text-xl font-bold">4.8</span>
                    <span className="text-text-secondary text-sm">km/h</span>
                  </div>
                  <p className="text-text-secondary text-sm mt-1">
                    Your pace is consistent. Try intervals of faster walking to increase calorie burn.
                  </p>
                </div>
                
                <div>
                  <h4 className="font-medium mb-2">Step Length</h4>
                  <div className="flex items-center gap-2">
                    <span className="text-xl font-bold">0.73</span>
                    <span className="text-text-secondary text-sm">meters</span>
                  </div>
                  <p className="text-text-secondary text-sm mt-1">
                    Your step length is ideal for your height. Maintain good posture for optimal results.
                  </p>
                </div>
              </div>
            </div>
            
            {/* Hydration */}
            <div className="bg-white rounded-xl shadow-sm p-6">
              <div className="flex items-center gap-3 mb-4">
                <Droplets size={20} className="text-secondary" />
                <h3 className="text-lg font-medium">Hydration Reminder</h3>
              </div>
              <p className="text-text-secondary mb-4">
                Based on your walking patterns, we recommend drinking water at these times:
              </p>
              <div className="flex flex-wrap gap-2">
                <div className="bg-secondary bg-opacity-10 text-secondary px-3 py-1 rounded-full text-sm">Before walks (7:30 AM)</div>
                <div className="bg-secondary bg-opacity-10 text-secondary px-3 py-1 rounded-full text-sm">Mid-day (12:00 PM)</div>
                <div className="bg-secondary bg-opacity-10 text-secondary px-3 py-1 rounded-full text-sm">After evening walk (6:30 PM)</div>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'history' && (
          <div className="space-y-6">
            {/* Performance Graph */}
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h3 className="text-lg font-medium mb-4">Performance Trends</h3>

              <div className="flex space-x-4 mb-4">
                         {["steps", "distance", "calories"].map((type) => (
                          <button
                            key={type}
                            onClick={() => handleSelect(type)}
                            className={`px-3 py-1 rounded-md text-sm ${
                              selectedType === type
                                ? "bg-primary text-white"
                                : "text-text-secondary hover:bg-background-light"
                            }`}
                          >
                            {type.charAt(0).toUpperCase() + type.slice(1)}
                          </button>
                        ))}
              </div>

              {/* Placeholder for line chart */}
              <div className="bg-gray-50 h-64 rounded-lg flex items-center justify-center">
                <div className="h-48 w-full">
                  {/* Simple mock line chart */}
                  {/* <svg viewBox="0 0 100 50" className="h-full w-full">
                    <path 
                      d="M0,35 L10,32 L20,28 L30,30 L40,25 L50,20 L60,15 L70,18 L80,10 L90,12 L100,8" 
                      fill="none" 
                      stroke="#4CAF50" 
                      strokeWidth="2" 
                    />
                    <path 
                      d="M0,35 L10,32 L20,28 L30,30 L40,25 L50,20 L60,15 L70,18 L80,10 L90,12 L100,8" 
                      fill="url(#gradient)" 
                      strokeWidth="0" 
                      opacity="0.2" 
                    />
                    <defs>
                      <linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop offset="0%" stopColor="#4CAF50" />
                        <stop offset="100%" stopColor="#4CAF50" stopOpacity="0" />
                      </linearGradient>
                    </defs>
                  </svg> */}

                   <svg viewBox="0 0 100 50" className="h-48 w-full">
                    {chartData.values.length > 1 && (
                      <path
                        d={generatePath(chartData.values)}
                        fill="none"
                        stroke="#4CAF50"
                        strokeWidth="2"
                      />
                    )}
                  </svg>
                </div>
              </div>
              
              <div className="flex justify-between mt-2 text-sm text-text-secondary">
              
                 {chartData.labels.map((label, idx) => (
                  <span key={idx}>{label}</span>
                ))}
              </div>
            </div>
            
            {/* Calendar Heat Map */}
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h3 className="text-lg font-medium mb-4">Activity Calendar</h3>
              <div className="grid grid-cols-7 gap-2">
                {/* Mock calendar data - day cells for current month */}
                {activityData?.calendar?.map((entry, i) => {
                  let bgColor = 'bg-gray-100';
                  if (entry.level === 'low') bgColor = 'bg-green-100';
                  if (entry.level === 'medium') bgColor = 'bg-green-300';
                  if (entry.level === 'high') bgColor = 'bg-green-500';

                  return (
                    <div key={i} className={`h-12 ${bgColor} rounded-md flex items-center justify-center text-sm`}>
                      {entry.day}
                    </div>
                  );
                })}
              </div>
              <div className="flex items-center justify-center mt-4 gap-4">
                <div className="flex items-center gap-2">
                  <div className="w-3 h-3 bg-gray-100 rounded-sm"></div>
                  <span className="text-xs text-text-secondary">No Activity</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-3 h-3 bg-green-100 rounded-sm"></div>
                  <span className="text-xs text-text-secondary">Low</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-3 h-3 bg-green-300 rounded-sm"></div>
                  <span className="text-xs text-text-secondary">Medium</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-3 h-3 bg-green-500 rounded-sm"></div>
                  <span className="text-xs text-text-secondary">High</span>
                </div>
              </div>
            </div>
            
            {/* Personal Records */}
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h3 className="text-lg font-medium mb-4">Personal Records</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="border border-gray-100 rounded-lg p-4">
                  <div className="flex items-center gap-2 mb-1">
                    <TrendingUp size={16} className="text-primary" />
                    <h4 className="text-sm font-medium">Most Steps</h4>
                  </div>
                  <div className="text-xl font-bold">{activityData?.records?.steps?.value.toLocaleString()}</div>
                  <div className="text-xs text-text-secondary mt-1">{activityData?.records?.steps?.date}</div>
                </div>
                
                <div className="border border-gray-100 rounded-lg p-4">
                  <div className="flex items-center gap-2 mb-1">
                    <Map size={16} className="text-primary" />
                    <h4 className="text-sm font-medium">Longest Distance</h4>
                  </div>

                 <div className="text-xl font-bold">
                  {activityData?.records?.distance?.value} km
                </div>
                <div className="text-xs text-text-secondary mt-1">
                  {activityData?.records?.distance?.date}
                </div>

                </div>
                
                <div className="border border-gray-100 rounded-lg p-4">
                  <div className="flex items-center gap-2 mb-1">
                    <Flame size={16} className="text-primary" />
                    <h4 className="text-sm font-medium">Most Calories</h4>
                  </div>
                   <div className="text-xl font-bold">
                      {activityData?.records?.calories?.value} kcal
                    </div>
                    <div className="text-xs text-text-secondary mt-1">
                      {activityData?.records?.calories?.date}
                    </div>
                </div>
              </div>
            </div>
            
            {/* Download Reports */}
             
          </div>
        )}

        {activeTab === 'challenges' && (
          <div className="space-y-6">
          {/* Active Challenges */}
          <div className="bg-white rounded-xl shadow-sm p-6">
            <h3 className="text-lg font-medium mb-4">Active Challenges</h3>
            <div className="space-y-4">
              {activeChallenges.map(challenge => (
                <div key={challenge.id} className="border border-gray-100 rounded-lg p-4">
                  <div className="flex justify-between items-start mb-2">
                    <h4 className="font-medium">{challenge.name}</h4>
                    <span className="bg-accent bg-opacity-10 text-accent text-xs px-2 py-1 rounded-full">
                      {challenge.daysLeft} days left
                    </span> 
                  </div>
                  <div className="w-full h-2 bg-gray-100 rounded-full mb-2">
                    <div
                      className="h-full bg-primary rounded-full"
                     style={{ width: `${Math.min(challenge.progress, 100)}%` }}

                    />
                  </div>
                  <div className="flex justify-between items-center text-sm text-text-secondary">
                   <span>Progress: {Math.min(challenge.progress, 100).toFixed(1)}%</span>
                    {/* <Link to={`/challenges/${challenge.id}`} className="text-primary font-medium">
                      View Details
                    </Link> */}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Available Challenges */}
          <div className="bg-white rounded-xl shadow-sm p-6 mt-8">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-medium">Available Challenges</h3>
              <Link to="/challenges" className="text-primary text-sm font-medium flex items-center gap-1">
                View All <ArrowRight size={12} />
              </Link>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {availableChallenges.map(challenge => (
                <div
                  key={challenge.id}
                  className="border border-gray-100 rounded-lg p-4 hover:border-primary transition-colors"
                >
                  <h4 className="font-medium mb-2">{challenge.name}</h4>
                  <div className="flex justify-between text-sm text-text-secondary mb-4">
                    <div className="flex items-center gap-1">
                      <Users size={14} />
                      <span>{challenge.participants} participants</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <Calendar size={14} />
                      <span>{challenge.duration}</span>
                    </div>
                  </div>
                  <button
                    onClick={() => joinChallenge(challenge.id)}
                    className="w-full bg-secondary bg-opacity-10 text-secondary px-3 py-2 rounded-md text-sm font-medium flex items-center justify-center gap-1"
                  >
                    <Plus size={14} />
                    Join Challenge
                  </button>
                </div>
              ))}
            </div>
          </div>
            
            {/* Current Goals */}
            <div className="bg-white rounded-xl shadow-sm p-6">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-medium">Current Goals</h3>
                <button 
                  // onClick={() => setModalOpen(true)}
                   onClick={openCreateModal}
                  className="bg-primary text-white px-3 py-1 rounded-md text-sm font-medium"
                >
                  Create Goal
                </button>
              </div>
              <div className="space-y-4">
                   {goals.map((goal) => {
  const progressPercentage = goal.progress || 0;
  const strokeDasharray = 251.2;
  const strokeDashoffset = strokeDasharray - (progressPercentage / 100) * strokeDasharray;

  // Goal-specific colors (you can expand this)
  const colorMap = {
    steps: '#4CAF50',
    distance: '#2196F3',
    calories: '#FF9800',
    duration: '#9C27B0',
  };

  const durationTextMap = {
    daily: 'Resets daily at midnight',
    weekly: 'Resets every Sunday',
    monthly: 'Resets on the 1st of each month',
  };

  const goalColor = colorMap[goal.type] || '#2196F3';
  const resetText = durationTextMap[goal.duration] || 'Repeats periodically';

  return (
    <div key={goal.id} className="border border-gray-100 rounded-lg p-4 space-y-2">
      <div className="flex justify-between items-center mb-3">
        <h4 className="font-medium">{goal.title}</h4>
        <button onClick={() => openEditModal(goal)} className="text-primary text-sm">
          Edit
        </button>
      </div>
      <div className="flex items-center gap-4">
        <div className="relative h-16 w-16">
          <svg viewBox="0 0 100 100" className="h-full w-full">
            <circle
              cx="50"
              cy="50"
              r="40"
              fill="none"
              stroke="#e6e6e6"
              strokeWidth="10"
            />
            <circle
              cx="50"
              cy="50"
              r="40"
              fill="none"
              stroke={goalColor}
              strokeWidth="10"
              strokeDasharray={strokeDasharray}
              strokeDashoffset={strokeDashoffset}
              strokeLinecap="round"
              transform="rotate(-90 50 50)"
            />
          </svg>
          <div className="absolute inset-0 flex items-center justify-center text-sm font-bold">
            {progressPercentage}%
          </div>
        </div>
        <div>
          <div className="text-lg font-bold">{goal.target_value} {goal.type}</div>
          <div className="text-text-secondary text-sm">{resetText}</div>
        </div>
      </div>
      {goal.description && (
        <p className="text-sm text-gray-500">{goal.description}</p>
      )}
    </div>
  );
})}

              </div>

            </div>
            
            {/* Achievements */}
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h3 className="text-lg font-medium mb-4">Achievements & Badges</h3>
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
                {achievements.map(achievement => (
                  <div key={achievement.id} className="flex flex-col items-center">
                    <div className="h-16 w-16 rounded-full bg-primary bg-opacity-10 flex items-center justify-center text-prima ry mb-2">
                      {achievement.icon}
                    </div>
                    <span className="text-sm text-center">{achievement.name}</span>
                  </div>
                ))}
                <div className="flex flex-col items-center">
                  <div className="h-16 w-16 rounded-full bg-gray-100 flex items-center justify-center text-gray-400">
                    <Award size={20} />
                  </div>
                  <span className="text-sm text-gray-400 text-center">7-Day Streak</span>
                </div>
                <div className="flex flex-col items-center">
                  <div className="h-16 w-16 rounded-full bg-gray-100 flex items-center justify-center text-gray-400">
                    <Heart size={20} />
                  </div>
                  <span className="text-sm text-gray-400 text-center">Health Hero</span>
                </div>
              </div>
              
              <div className="mt-4 text-center">
                {/* <Link to="/achievements" className="text-primary text-sm font-medium inline-flex items-center gap-1">
                  View All Achievements <ArrowRight size={12} />
                </Link> */}
              </div>
            </div>


          </div>
        )}
      </main>

      {/* Mobile Navigation */}
      {/* <nav className="lg:hidden fixed bottom-0 left-0 right-0 bg-white shadow-[0_-2px_10px_rgba(0,0,0,0.1)] z-10">
        <div className="flex justify-around items-center">
          {navigationItems.map((item, index) => (
            <Link 
              key={index} 
              to={item.link} 
              className={`flex flex-col items-center py-3 px-2 ${item.active ? 'text-primary' : 'text-text-secondary'}`}
            >
              {item.icon}
              <span className="text-xs mt-1">{item.label}</span>
            </Link>
          ))}
        </div>
      </nav> */}

      {/* Desktop Sidebar - Hidden on mobile */}
      <nav className="hidden lg:flex fixed left-0 top-0 bottom-0 w-64 bg-white shadow-sm z-20 flex-col">
      <Navigation />
      </nav>
       <div className="md:hidden block sticky bottom-0 z-50 bg-white border-t border-gray-200 p-2">
        <Navigation orientation='horizontal' />
      </div>


      {/* The Modal Component */}
      <GoalModal
        isOpen={isModalOpen}
        onClose={closeModal}
        onGoalSaved={handleGoalSaved}
        goalToEdit={goalToEdit}
        goalCount={goalCount}
      />


    </div>
  );
};

export default Dashboard;